import React from "react";
import "./PreviousRx.css";
const PreviousRx = () => {
  return (
    <div className="p-4">
      <table className="w-full">
        <thead></thead>
        <tbody>
          <tr>
            <td>
              <p>Previous RX</p>
              <br />
              <p>
                (Click here to pre-populate with patient Previous subjective RX)
              </p>
            </td>
            <td>
              {" "}
              <p>Previous RX(Incl from Autorefraction)</p>
            </td>
          </tr>

          <tr>
            <td>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>SPH</th>
                    <th>CYL</th>
                    <th>Axis</th>
                    <th>Prism</th>
                    <th>Direction</th>
                    <th>Add</th>
                    <th>VA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>R:</td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td className="text-center">
                      <select className="w-8 border border-gray-200 p-3 rounded-md">
                        <option value="select">Select</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>L:</td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td className="text-center">
                      <select className="w-8 border border-gray-200 p-3 rounded-md">
                        <option value="select">Select</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th>SPH</th>
                    <th>CYL</th>
                    <th>Axis</th>
                    <th>Prism</th>
                    <th>Direction</th>
                    <th>Add</th>
                    <th>VA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>R:</td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td className="text-center">
                      <select className="w-8 border border-gray-200 p-3 rounded-md">
                        <option value="select">Select</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>L:</td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td className="text-center">
                      <select className="w-8 border border-gray-200 p-3 rounded-md">
                        <option value="select">Select</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="w-8 border border-y-gray-200 rounded-md"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PreviousRx;
